module.exports = __webpack_public_path__ + "img/mobile_banking_scb.c29c3d6c.png";